
export const ADD_NEW_LN = 'ADD_NEW_LN';
export const DEL_NEW_LN = 'DEL_NEW_LN';
export const UPDATE_STATE_LAYER = 'UPDATE_STATE_LAYER';
export const UPDATE_STATE_LAYER_LOCAL = 'UPDATE_STATE_LAYER_LOCAL';
export const ADD_LAYER_IN_PANEL = 'ADD_LAYER_IN_PANEL';
export const REMOVE_LAYER_IN_PANEL = 'REMOVE_LAYER_IN_PANEL';
export const ADD_SUBLAYER_TO_SOURCE = 'ADD_SUBLAYER_TO_SOURCE';
export const REMOVE_SUBLAYER_TO_SOURCE = 'REMOVE_SUBLAYER_TO_SOURCE';